<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="text-h5">Rigg og drift</div>

                <div class="d-flex flex-wrap" style="width: 100%; height: 100%;">
                    <v-card class="ma-2">
                        <v-card-title class="grey lighten-3 headline">
                            <div class="text-h6">Riggplan</div>
                        </v-card-title>
                        <v-card-text>
                            <div v-if="siteplans.length === 0">Ingen riggplaner</div>
                            <div class="d-flex">
                                <div v-for="siteplan in siteplans" :key="siteplan" class="ma-2" style="cursor: pointer; height: 30vmin; width: 30vmin;" @click="() => { content = siteplan; contentShow = true;}">
                                    <v-progress-linear v-if="!siteplan.src" indeterminate></v-progress-linear>
                                    <v-img v-if="/^data:image\/.*/.test(siteplan.src) && !!siteplan.src" :src="siteplan.src" contain height="100%" width="100%">
                                    </v-img>
                                    <div v-if="/^data:image\/.*/.test(siteplan.src) && !siteplan.src" style="background: red; height:100%; width:100%;">
                                        <v-progress-circular indeterminate></v-progress-circular>
                                    </div>

                                    <div style="width: 100%; height: 100%;">
                                        <!-- <iframe v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :src="`${siteplan.url}#view=Fit&toolbar=0&scrollbar=0`" allowfullscreen="false" width="100%" height="100%" style="scrolling: no; pointer-events: none; height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;">
                                        </iframe> -->
                                         <iframe v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :src="`${siteplan.url}#view=Fit&toolbar=0&scrollbar=0`" allowfullscreen="false" style="scrolling: 'no'; pointer-events: none; height: 100%; width: 100%; padding: 0px; margin: 0px; border: none;">
                                        </iframe>
                                    </div>

                                    <div v-if="/^data:application\/pdf.*/.test(siteplan.src) && (!siteplan.src || siteplan.src.length == 0)" style="background: red">
                                        <v-progress-circular indeterminate></v-progress-circular>
                                    </div>

                                </div>
                            </div>

                        </v-card-text>
                    </v-card>

                    <v-card class="ma-2">
                        <v-card-title class="grey lighten-3 headline">
                            <div class="text-h6">Veibeskrivelse</div>
                        </v-card-title>
                        <v-card-text>
                            <div v-if="directions.length === 0">Ingen veibeskrivelser</div>
                            <div class="d-flex">
                                <div v-for="direction in directions" :key="direction" class="ma-2" style="cursor: pointer; height: 30vmin; width: 30vmin;" @click="() => { content = direction; contentShow = true;}">
                                    <v-progress-linear v-if="!direction.src" indeterminate></v-progress-linear>
                                    <v-img v-if="/^data:image\/.*/.test(direction.src) && !!direction.src" :src="direction.src" height="100%" width="100%" contain>
                                    </v-img>
                                    <div v-if="/^data:image\/.*/.test(direction.src) && !direction.src" style="background: red; height:100%; width:100%;">
                                        <v-progress-circular indeterminate></v-progress-circular>
                                    </div>

                                    <iframe v-if="/^data:application\/pdf.*/.test(direction.src) && !!direction.src" :src="`${direction.url}#view=Fit&toolbar=0`" width="100%" height="100%" allowfullscreen="false" style="scrolling: no; pointer-events: none; height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;">
                                    </iframe>
                                    <div v-if="/^data:application\/pdf.*/.test(direction.src) && (!direction.src || direction.src.length == 0)" style="background: red">
                                        <v-progress-circular indeterminate></v-progress-circular>
                                    </div>

                                </div>
                            </div>

                        </v-card-text>
                    </v-card>
                </div>

            </v-col>

        </v-row>

        <v-dialog v-model="contentShow" @keydown.esc="() => {contentShow = false; contentFullscreen = false;}">
            <div v-if="content && content.name" style="max-height: 90vmin; background: white; position: relative;">
                <div style="position: absolute; background: rgba(255,255,255,0.65); z-index: 10;" class="ma-2 pa-2 text-h6">{{/.*\/.*\/(.*)/.exec(content.name)[1]}}</div>
                <div style="position: absolute; top: 10px; right: 10px; z-index: 10; display: flex; flex-direcion: row;">
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => {contentFullscreen = !contentFullscreen;}">
                        <v-icon v-if="contentFullscreen">mdi-fullscreen-exit</v-icon>
                        <v-icon v-else>mdi-fullscreen</v-icon>
                    </v-btn>
                    <div class="mx-1"></div>
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => { contentShow = false; contentFullscreen = false;}">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-img v-if="!contentFullscreen" :src="content.src" class="ma-auto" max-height="90vmin" max-width="90vmin" :contain="!contentFullscreen"></v-img>
                <v-img v-else :src="content.src" class="ma-auto"></v-img>

            </div>
        </v-dialog>
    </v-container>
</template>
<script>
// import axios from "axios";

export default {
    data() {
        return {
            contentShow: false,
            contentFullscreen: false,
            content: {
                name: undefined
            }
        };
    },
    computed: {
        siteplans() {
            return this.$store.getters.filesByType("siteplans");
        },
        directions() {
            return this.$store.getters.filesByType("directions");
        }
    },
    methods: {
        async listSiteplans() {
            let siteplans = await this.$store.dispatch("listFiles","siteplans");
            let directions = await this.$store.dispatch("listFiles","directions");

            let files = [...siteplans, ...directions];

            files.forEach(async (file) => {
                await this.$store.dispatch("addFile", file);
                if(!this.$store.getters.file(file.name).src){
                    let {binary, buffer, src, blob, url} = await this.$store.dispatch("downloadFile", file.name);

                    this.$set(file, "binary", binary);
                    this.$set(file, "buffer", buffer);
                    this.$set(file, "src", src);
                    this.$set(file, "blob", blob);
                    this.$set(file, "url", url);
                    await this.$store.dispatch("addFile", file);
                }
            });
        }
    },
    mounted() {
        // this.fetchPlans();
        this.listSiteplans();
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>
<style lang="scss" scoped>
</style>
